import { PolicyDecisionConditionCategoryTypes } from "@enums/policy-decision-condition-category-types";

export const POLICY_CATEGORY_OPTIONS = [
    {
        label: "Control",
        value: PolicyDecisionConditionCategoryTypes.CONTROL
    },
    {
        label: "Risk",
        value: PolicyDecisionConditionCategoryTypes.RISK
    },
    {
        label: "Verification",
        value: PolicyDecisionConditionCategoryTypes.VERIFICATION
    }
]